import React from "react"
import { Container,Row,Col } from 'react-bootstrap';

const Footer = ( props ) =>{

	return(
    <footer className="Footer">
        <Container>
            <Row>
                <Col>
                    <p>
                        本サイトはジャパンライム株式会社によって管理・運営されています。<br/>
                        本サイトに掲載されている映像・画像・文章等、全ての内容の無断転載・引用を禁止します。
                    </p>
                    <p>
                    <a href="https://www.japanlaim.co.jp/company/" target="_blank">会社情報</a>
                    <a href="https://www.japanlaim.co.jp/privacy.html" target="_blank">個人情報保護方針</a>
                    </p>
                    <p><small>© 2020 JapanLaim Co.,Ltd All Rights Reserved.</small></p>
                </Col>
            </Row>
        </Container>
    </footer>
    )
}

export default Footer